const topSectionsHeight = 60 + 45;

let dragPositionY = 0;
const dragThreshold = -60;

let minMarginTop = -1;
let maxMarginTop = document.querySelector('.section-main-product')?.offsetTop - topSectionsHeight - 27;
let isDetailsSticky = true;

let isImagesScrollEnd = false;
let imagesDragLength = 0;
let detailsDragLength = 0;

function animateMargin(targetPositionY) {
  const section = document.querySelector('.section-main-product');
  const initialPositionY = section.offsetTop - topSectionsHeight;
  const duration = 200;
  const distanceY = targetPositionY - initialPositionY;

  // Get the start time
  let startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;

    // Calculate the elapsed time since the animation started
    const elapsedTime = timestamp - startTime;

    // Calculate the current position based on the elapsed time and duration
    const currentPositionY = initialPositionY + distanceY * (elapsedTime / duration);

    // Apply the translateY transformation to the element
    section.style.marginTop = `${currentPositionY}px`;

    // Check if the animation is still in progress
    if (elapsedTime < duration) {
      // If the animation is not finished, continue animating
      requestAnimationFrame(animate);
    } else {
      // Animation has finished, set the final position
      section.style.marginTop = `${targetPositionY}px`;
    }
  }

  // Start the animation
  requestAnimationFrame(animate);
}

let productDetailsInteract = null;

// function setDraggable() {
//   productDetailsInteract = interact('.product-details__top').draggable({
//     listeners: {
//       start(event) {
//         hideColorSelector();
//         // document.querySelector('#template-main-product')?.classList.remove('is-top');
//       },
//       move(event) {
//         const section = document.querySelector('.section-main-product');
//         dragPositionY += event.dy;

//         let currentPositionY = isDetailsSticky ? maxMarginTop - dragPositionY * -1 : minMarginTop - dragPositionY * -1;

//         if (currentPositionY < minMarginTop) {
//           currentPositionY = minMarginTop;
//         }

//         section.style.marginTop = `${currentPositionY}px`;
//       },
//       end(event) {
//         if (
//           (isDetailsSticky && dragPositionY < dragThreshold) ||
//           (!isDetailsSticky && dragPositionY < dragThreshold * -1)
//         ) {
//           setToTop();
//         } else {
//           setToBottom();
//         }

//         dragPositionY = 0;
//       },
//     },
//   });
// }

function setToTop() {
  animateMargin(0);
  isDetailsSticky = false;

  setTimeout(() => {
    document.querySelector('.section-main-product')?.classList.add('is-top');
    document.querySelector('body')?.classList.add('scrollable');
  }, 200);
}

function setToBottom() {
  animateMargin(maxMarginTop);

  setTimeout(() => {
    isDetailsSticky = true;
    document.querySelector('.section-main-product')?.classList.remove('is-top');
    document.querySelector('body')?.classList.remove('scrollable');
  }, 200);
}

// function handleWindowResize() {
//   if (window.innerWidth < 750) {
//     setDraggable();
//   }
// }

function throttleNew(cb, delay) {
  let wait = false;
  let storedArgs = null;

  function checkStoredArgs() {
    if (storedArgs == null) {
      wait = false;
    } else {
      cb(...storedArgs);
      storedArgs = null;
      setTimeout(checkStoredArgs, delay);
    }
  }

  return (...args) => {
    if (wait) {
      storedArgs = args;
      return;
    }

    cb(...args);
    wait = true;
    setTimeout(checkStoredArgs, delay);
  };
}

function registerDesktopImageThumbnails() {
  const thumbnails = document.querySelectorAll('.thumbnail-wrapper');

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      const imagesContainer = document.querySelector('.main-product__images');
      const images = [...document.querySelectorAll('.image-wrapper')];
      const image = images[index];

      imagesContainer.scrollTo({ top: image.offsetTop, behavior: 'smooth' });

      thumbnails.forEach((thumbnail) => thumbnail.classList.remove('active'));
      thumbnail.classList.add('active');
    });
  });
}

function updateThumbnails() {
  const imagesContainer = document.querySelector('.main-product__images');
  const images = [...document.querySelectorAll('.image-wrapper')];
  const thumbnails = document.querySelectorAll('.thumbnail-wrapper');
  const scrollPosition = imagesContainer.scrollTop;
  const imagesInView = images.filter(
    (_) => _.offsetTop <= scrollPosition && _.offsetTop + _.offsetHeight >= scrollPosition
  );

  if (imagesInView.length === 0) return;

  thumbnails.forEach((thumbnail) => thumbnail.classList.remove('active'));
  const activeIndex = imagesInView[imagesInView.length - 1].dataset.index;
  const activeThumbnail = thumbnails[activeIndex];

  activeThumbnail.classList.add('active');
}

function registerDesktopImageScrollHandler() {
  const imagesContainer = document.querySelector('.main-product__images');

  imagesContainer.addEventListener('scroll', () => {
    updateThumbnails();
  });
}

function toggleModelSizeDropdown() {
  const modelSizeDropdown = document.querySelector('.image-filter__wrapper');

  if (modelSizeDropdown === null) {
    return;
  }

  modelSizeDropdown.classList.toggle('active');
}

function closeModelSizeDropdown() {
  const modelSizeDropdown = document.querySelector('.image-filter__wrapper');

  if (modelSizeDropdown === null) {
    return;
  }

  modelSizeDropdown.classList.remove('active');
}

function toggleColorSelector() {
  const colorSelector = document.querySelector('.color-selector');

  if (colorSelector === null) {
    return;
  }

  colorSelector.classList.toggle('active');

  if (!isDetailsSticky) {
    setToBottom();
  }
}

function hideColorSelector() {
  const colorSelector = document.querySelector('.color-selector');

  if (colorSelector === null) {
    return;
  }

  colorSelector.classList.remove('active');
}

function handleColorChange(event) {
  let colorSwatch = event.target;

  if (!colorSwatch.classList.contains('color-swatch')) {
    colorSwatch = colorSwatch.closest('.color-swatch');
  }

  const productUrl = colorSwatch.dataset.productUrl;
  replaceProduct(productUrl);
}

function openOptionSelector() {
  const optionPopup = document.querySelector('.product-option__popup');

  if (optionPopup === null) {
    return;
  }

  if (!isDetailsSticky) {
    setToBottom();
  }

  optionPopup.classList.add('active');
  const optionOptions = document.querySelector('.product-option__options-wrapper');
  const popupContent = optionPopup.querySelector('.product-option__content');
  popupContent.innerHTML = optionOptions.innerHTML;
  // optionPopup.style.transform = `translateY(${optionPopup.offsetHeight * -1}px)`;

  registerMobileOptionSelectEvents();
  registerOutsideClickEvent();
}

function closeOptionSelector() {
  const optionPopup = document.querySelector('.product-option__popup');

  if (optionPopup === null) {
    return;
  }

  optionPopup.classList.remove('active');
  optionPopup.style.transform = `translateY(0px)`;
}

function registerDesktopOptionSelectEvents() {
  const values = document.querySelectorAll(
    '.product-option__options-wrapper > .product-option__values > .product-option__value'
  );

  values.forEach((value) => {
    value.addEventListener('click', handleDesktopValueSelect);
  });
}

function handleDesktopValueSelect(event) {
  const target = event.target;
  const variantId = target.dataset.variantId;
  const variantUrl = target.dataset.variantUrl;
  const isSoldOut = target.classList.contains('sold-out');

  if (!variantUrl) {
    console.error('No variant URL found');
    return;
  }

  // Update variant selection UI
  document.querySelectorAll('.product-option__value').forEach((value) => {
    value.classList.remove('active');
  });
  document.querySelector('.product-option__value[data-variant-id="' + variantId + '"]').classList.add('active');

  // Update form ID
  const formIdInput = document.querySelector('form.product-form input[name="id"]');
  formIdInput.value = variantId;

  // Fetch updated product information
  fetch(
    `${variantUrl}?section_id=${document
      .querySelector('.main-product__wrapper')
      .closest('.shopify-section')
      .id.replace('shopify-section-', '')}`
  )
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update price
      const newPriceElement = doc.querySelector('.product__price');
      const currentPriceElement = document.querySelector('.product__price');
      if (newPriceElement && currentPriceElement) {
        currentPriceElement.innerHTML = newPriceElement.innerHTML;
      }

      // Update URL
      window.history.replaceState({}, '', variantUrl);

      // Update availability
      const formWrapper = document.querySelector('.form__wrapper');
      const addToCart = document.querySelector('[data-add-to-cart]:not([data-upsell-btn])');
      const addToCartText = document.querySelector('[data-add-to-cart-text]');
      const backInStockBtn = document.querySelector('.klaviyo-bis-trigger');

      if (isSoldOut) {
        formWrapper.classList.add('variant--soldout');
        addToCart.setAttribute('disabled', 'disabled');
        addToCartText.innerHTML = 'Sold Out';
        backInStockBtn.style.display = "flex";
      } else {
        formWrapper.classList.remove('variant--soldout');
        addToCart.removeAttribute('disabled');
        addToCartText.innerHTML = 'Add to Cart';
        backInStockBtn.style.display = "none";
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

registerOutsideClickEvent = () => {
  document.querySelector('.product-grid__item:first-child').addEventListener('click', closeOptionSelector);
};

function registerMobileOptionSelectEvents() {
  const optionPopupValues = document.querySelectorAll('.product-option__popup .product-option__value');

  optionPopupValues.forEach((value) => {
    value.addEventListener('click', handleMobileValueSelect);
  });
}

registerOutsideClickEvent = () => {
  document.querySelector('.product-grid__item:first-child').addEventListener('click', closeOptionSelector);
};

function handleMobileValueSelect(event) {
  const value = event.target.dataset.value;
  const variantId = event.target.dataset.variantId;
  const variantUrl = event.target.dataset.variantUrl;
  const isSoldOut = event.target.classList.contains('sold-out');

  document.querySelectorAll('.product-option__value').forEach((value) => {
    value.classList.remove('active');
  });

  document.querySelector('.product-option__value[data-variant-id="' + variantId + '"]').classList.add('active');

  const button = document.querySelector('.product-option__button');
  const formIdInput = document.querySelector('form.product-form input[name="id"]');

  if (button == null) {
    return;
  }

  button.innerHTML = value;
  formIdInput.value = variantId;
  closeOptionSelector();

  window.history.replaceState({}, '', variantUrl);

  const formWrapper = document.querySelector('.form__wrapper');
  const addToCart = document.querySelector('[data-add-to-cart]:not([data-upsell-btn])');
  const addToCartText = document.querySelector('[data-add-to-cart-text]');

  if (isSoldOut) {
    formWrapper.classList.add('variant--soldout');
    addToCart.setAttribute('disabled', 'disabled');
    addToCartText.innerHTML = 'Sold Out';
  } else {
    formWrapper.classList.remove('variant--soldout');
    addToCart.removeAttribute('disabled');
    addToCartText.innerHTML = 'Add to Cart';
  }
}

const replaceHtml = (doc, selector) => {
  const existingNode = document.querySelector(selector);
  const newNode = doc.querySelector(selector);

  if (existingNode != null) {
    if (newNode) {
      existingNode.outerHTML = newNode.outerHTML;
    } else {
      existingNode.remove();
    }
  }
};

const replaceColorSelector = (doc) => {
  const nodeSelector = '.color-selector';
  const colorSelector = doc.querySelector(nodeSelector);

  if (colorSelector) {
    colorSelector.classList.add('active');
    document.querySelector(nodeSelector).outerHTML = colorSelector.outerHTML;
  }
};

const replaceFormClasses = (doc) => {
  const nodeSelector = '.form__wrapper';
  const formWrapper = doc.querySelector(nodeSelector);

  if (formWrapper) {
    const newClasses = formWrapper.classList;
    document.querySelector(nodeSelector).classList = newClasses;
  }
};

const replaceProduct = (productUrl) => {
  variantURL = `${productUrl}`;

  const sectionId = document
    .querySelector('.main-product__wrapper')
    .closest('.shopify-section')
    .id.split('shopify-section-')[1];

  const fetchVariantURL = `${variantURL}?section_id=${sectionId}`;

  document.querySelector('.product-images-loader').classList.add('show');

  fetch(fetchVariantURL)
    .then((response) => {
      return response.text();
    })
    .then((html) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      // Images
      replaceHtml(doc, '.main-product__images');

      // Image filters
      replaceHtml(doc, '.image-filter__wrapper');

      // Image thumbnails
      replaceHtml(doc, '.main-product__thumbnails');

      // Colors (Mobile)
      if (doc.querySelector('.main-product__color__wrapper.js-color-toggle')) {
        replaceColorSelector(doc);
      }

      // Colors (Desktop)
      replaceHtml(doc, '.main-product__color__wrapper');

      // Title and price
      replaceHtml(doc, '.main-product__title__wrapper');

      // Tabs
      replaceHtml(doc, '.productTabsWrapper');

      // Upsell
      replaceHtml(doc, '.product-upsell-wrapper');

      // Form
      replaceHtml(doc, ".product-form input[name='id']");
      // replaceHtml(doc, ".product__submit__buttons");
      replaceHtml(doc, '.product-form__buttons');
      replaceHtml(doc, '.image-release__wrapper');
      replaceFormClasses(doc);

      // replaceHtml(doc, '#back-in-stock-helper');
      // replaceHtml(doc, '#bis-product-json');
      // replaceHtml(doc, '#bis-variant-json');

      registerEvents();

      new GlobalAccordions(document);

      const els = document.querySelectorAll(`[${selectors$e.tooltip}]`);
      els.forEach((el) => {
        new Tooltip(el);
      });

      document.querySelector('.product-images-loader').classList.remove('show');
      window.history.pushState({}, '', variantURL);

      if (window.cevoid) {
        window.cevoid.reloadAll();
      }

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      // if (window.BIS) {
      //   document.querySelectorAll('#BIS_frame').forEach((frame) => {
      //     frame.remove();
      //   });
      //   const bisTriggers = document.querySelectorAll('#BIS_trigger');

      //   // Remove all triggers except the last
      //   bisTriggers.forEach((trigger, index) => {
      //     if (index < bisTriggers.length - 1) {
      //       trigger.remove();
      //     }
      //   });

      //   window.BISConfig = BIS.Config;
      //   BIS.domReady().then(BIS.init);
      //   new BIS.Analytics().init();

      //   // console.log(BIS)
      // }
    })
    .catch((error) => {
      console.warn('Something went wrong', error);
    });
};

const slideDown = (target, duration = 500, showDisplay = 'block', checkHidden = true) => {
  let display = window.getComputedStyle(target).display;
  if (checkHidden && display !== 'none') {
    return;
  }
  target.style.removeProperty('display');
  if (display === 'none') display = showDisplay;
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideUp = (target, duration = 500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideToggle = (target, duration = 500, showDisplay = 'block') => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration, showDisplay);
  } else {
    return slideUp(target, duration);
  }
};

const showElement = (elem, removeProp = false, prop = 'block') => {
  if (elem) {
    if (removeProp) {
      elem.style.removeProperty('display');
    } else {
      elem.style.display = prop;
    }
  }
};

const throttle = (fn, wait) => {
  let prev, next;
  return function invokeFn(...args) {
    const now = Date.now();
    next = clearTimeout(next);
    if (!prev || now - prev >= wait) {
      // eslint-disable-next-line prefer-spread
      fn.apply(null, args);
      prev = now;
    } else {
      next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev));
    }
  };
};

const selectors$G = {
  elements: {
    accordionHolder: '[data-accordion-holder]',
    accordion: '[data-accordion]',
    accordionToggle: '[data-accordion-toggle]',
    accordionBody: '[data-accordion-body]',
    accordionExpandValue: 'data-accordion-expand',
    accordionBlockValue: 'data-block-id',
  },
  classes: {
    open: 'is-open',
  },
};

const sections$j = {};

class GlobalAccordions {
  constructor(el) {
    this.container = el;
    this.accordion = this.container.querySelector(selectors$G.elements.accordion);
    this.accordionToggles = this.container.querySelectorAll(selectors$G.elements.accordionToggle);
    this.accordionTogglesLength = this.accordionToggles.length;
    this.accordionBody = this.container.querySelector(selectors$G.elements.accordionBody);

    if (this.accordionTogglesLength && this.accordionBody) {
      this.accordionEvents();
    }
  }

  accordionEvents() {
    this.accordionToggles.forEach((element) => {
      element.addEventListener(
        'click',
        throttle((event) => {
          event.preventDefault();
          const targetAccordionBody = element.parentElement.querySelector(selectors$G.elements.accordionBody);
          if (targetAccordionBody) {
            this.onAccordionToggle(element, targetAccordionBody);
          }
        }, 800)
      );
    });

    if (this.accordion.getAttribute(selectors$G.elements.accordionExpandValue) === 'true') {
      this.accordionToggles[0].classList.add(selectors$G.classes.open);

      showElement(this.accordionToggles[0].parentElement.querySelector(selectors$G.elements.accordionBody));
    }
  }

  closeOtherAccordions(element, slide = true) {
    let otherElements = [...this.accordionToggles];
    const holder = this.container.closest(selectors$G.elements.accordionHolder);
    if (holder) {
      otherElements = [...holder.querySelectorAll(selectors$G.elements.accordionToggle)];
    }

    otherElements.filter((otherElement) => {
      const otherElementAccordionBody = otherElement.parentElement.querySelector(selectors$G.elements.accordionBody);
      if (
        otherElement !== element &&
        otherElement.classList.contains(selectors$G.classes.open) &&
        otherElementAccordionBody
      ) {
        this.onAccordionClose(otherElement, otherElementAccordionBody, slide);
      }
    });
  }

  onAccordionOpen(element, body, slide = true) {
    element.classList.add(selectors$G.classes.open);
    slideDown(body);

    this.closeOtherAccordions(element, slide);
  }

  onAccordionClose(element, body, slide = true) {
    element.classList.remove(selectors$G.classes.open);
    if (slide) {
      slideUp(body);
    } else {
      hideElement(body);
    }
  }

  onAccordionToggle(element, body) {
    element.classList.toggle(selectors$G.classes.open);
    slideToggle(body);

    this.closeOtherAccordions(element);
  }
}

const selectors$e = {
  tooltip: 'data-tooltip',
  tooltipStopMouseEnter: 'data-tooltip-stop-mouseenter',
};

const classes$5 = {
  tooltipDefault: 'tooltip-default',
  visible: 'is-visible',
  hiding: 'is-hiding',
};

class Tooltip {
  constructor(el, options = {}) {
    this.tooltip = el;
    if (!this.tooltip.hasAttribute(selectors$e.tooltip)) return;
    this.label = this.tooltip.getAttribute(selectors$e.tooltip);
    this.class = options.class || classes$5.tooltipDefault;
    this.transitionSpeed = options.transitionSpeed || 200;
    this.hideTransitionTimeout = 0;
    this.addPinEvent = () => this.addPin();
    this.addPinMouseEvent = () => this.addPin(true);
    this.removePinEvent = (event) => throttle(this.removePin(event), 50);
    this.removePinMouseEvent = (event) => this.removePin(event, true, true);
    this.init();
  }

  init() {
    if (!document.querySelector(`.${this.class}`)) {
      const tooltipTemplate = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`;
      const tooltipElement = document.createElement('div');
      tooltipElement.className = this.class;
      tooltipElement.innerHTML = tooltipTemplate;
      document.body.appendChild(tooltipElement);
    }

    this.tooltip.addEventListener('mouseenter', this.addPinMouseEvent);
    this.tooltip.addEventListener('mouseleave', this.removePinMouseEvent);
    this.tooltip.addEventListener('tooltip:init', this.addPinEvent);
    document.addEventListener('tooltip:close', this.removePinEvent);
  }

  addPin(stopMouseEnter = false) {
    const tooltipTarget = document.querySelector(`.${this.class}`);

    if (
      tooltipTarget &&
      ((stopMouseEnter && !this.tooltip.hasAttribute(selectors$e.tooltipStopMouseEnter)) || !stopMouseEnter)
    ) {
      const tooltipTargetArrow = tooltipTarget.querySelector(`.${this.class}__arrow`);
      const tooltipTargetInner = tooltipTarget.querySelector(`.${this.class}__inner`);
      const tooltipTargetText = tooltipTarget.querySelector(`.${this.class}__text`);
      tooltipTargetText.textContent = this.label;

      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const tooltipTargetWidth = tooltipTargetInner.offsetWidth;
      const tooltipRect = this.tooltip.getBoundingClientRect();
      const tooltipTop = tooltipRect.top;
      const tooltipWidth = tooltipRect.width;
      const tooltipHeight = tooltipRect.height;
      const tooltipTargetPositionTop = tooltipTop + tooltipHeight + window.scrollY;
      let tooltipTargetPositionLeft = tooltipRect.left - tooltipTargetWidth / 2 + tooltipWidth / 2;
      const tooltipLeftWithWidth = tooltipTargetPositionLeft + tooltipTargetWidth;
      const tooltipTargetWindowDifference = tooltipLeftWithWidth - windowWidth;

      if (tooltipTargetWindowDifference > 0) {
        tooltipTargetPositionLeft -= tooltipTargetWindowDifference;
      }

      if (tooltipTargetPositionLeft < 0) {
        tooltipTargetPositionLeft = 0;
      }

      tooltipTargetArrow.style.left = `${tooltipRect.left + tooltipWidth / 2}px`;
      tooltipTarget.style.top = `${tooltipTargetPositionTop}px`;
      tooltipTargetInner.style.transform = `translateX(${tooltipTargetPositionLeft}px)`;
      tooltipTarget.classList.remove(classes$5.hiding);
      tooltipTarget.classList.add(classes$5.visible);

      document.addEventListener('theme:scroll', this.removePinEvent);
      tooltipTarget.addEventListener('click', this.removePinEvent);
    }
  }

  removePin(event, stopMouseEnter = false, hideTransition = false) {
    const tooltipTarget = document.querySelector(`.${this.class}`);
    const tooltipVisible = tooltipTarget.classList.contains(classes$5.visible);

    if (
      tooltipTarget &&
      ((stopMouseEnter && !this.tooltip.hasAttribute(selectors$e.tooltipStopMouseEnter)) || !stopMouseEnter)
    ) {
      if (tooltipVisible && (hideTransition || event.detail.hideTransition)) {
        tooltipTarget.classList.add(classes$5.hiding);

        if (this.hideTransitionTimeout) {
          clearTimeout(this.hideTransitionTimeout);
        }

        this.hideTransitionTimeout = setTimeout(() => {
          tooltipTarget.classList.remove(classes$5.hiding);
        }, this.transitionSpeed);
      }

      tooltipTarget.classList.remove(classes$5.visible);

      document.removeEventListener('theme:scroll', this.removePinEvent);
    }
  }

  unload() {
    this.tooltip.removeEventListener('mouseenter', this.addPinMouseEvent);
    this.tooltip.removeEventListener('mouseleave', this.removePinMouseEvent);
    this.tooltip.removeEventListener('tooltip:init', this.addPinEvent);
    document.removeEventListener('tooltip:close', this.removePinEvent);
    document.removeEventListener('theme:scroll', this.removePinEvent);
  }
}

function registerColorSwatches() {
  document.querySelectorAll('.js-color-swatch').forEach((color) => {
    color.addEventListener('click', handleColorChange);
  });
}

function registerColorSelectorToggle() {
  document.querySelector('.js-color-toggle')?.addEventListener('click', toggleColorSelector);
}

function handleImagesScroll(event) {
  var scrollTop = event.target.scrollTop;
  var scrollHeight = event.target.scrollHeight;
  var offsetHeight = event.target.offsetHeight;
  var contentHeight = scrollHeight - offsetHeight;

  if (contentHeight <= scrollTop) {
    isImagesScrollEnd = true;
  } else if (isImagesScrollEnd) {
    isImagesScrollEnd = false;
  }
}

function registerImagesScroll() {
  document.querySelector('.main-product__images')?.addEventListener('scroll', handleImagesScroll);

  interact('.main-product__images').draggable({
    listeners: {
      start(event) {
        imagesDragLength = 0;
      },
      move(event) {
        if (!isImagesScrollEnd) {
          return;
        }

        imagesDragLength += event.dy;

        if (imagesDragLength < -3 && isDetailsSticky) {
          setToTop();
        }
      },
      end(event) {
        imagesDragLength = 0;
      },
    },
  });
}

// function registerNonStickyDetailsScroll() {
//   interact('.product-details').draggable({
//     listeners: {
//       start(event) {
//         detailsDragLength = 0;
//       },
//       move(event) {
//         if (isDetailsSticky) {
//           return;
//         }

//         detailsDragLength += event.dy;

//         if (detailsDragLength > 10) {
//           setToBottom();
//         }
//       },
//       end(event) {
//         detailsDragLength = 0;
//       },
//     },
//   });
// }

function registerOptionSelectorOpen() {
  const productOptionButton = document.querySelector('.product-option__button');

  if (!productOptionButton) {
    return;
  }

  productOptionButton.addEventListener('click', openOptionSelector);
}

function handleModelOptionClick(event) {
  const isAll = event.target.classList.contains('all-selector');

  if (isAll) {
    document.querySelectorAll('.image-filter__dropdown-item').forEach((tag) => {
      tag.classList.remove('selected');
    });

    event.target.classList.add('selected');
  } else {
    document.querySelector('.image-filter__dropdown-item.all-selector').classList.remove('selected');
    event.target.classList.toggle('selected');
  }

  const selectedTags = [...document.querySelectorAll('.image-filter__dropdown-item.selected')].map((tag) => {
    return tag.dataset.value;
  });

  if (selectedTags.length === 0) {
    selectedTags.push('all');
    document.querySelector('.image-filter__dropdown-item.all-selector').classList.add('selected');
  }

  if (selectedTags.length === 1 && selectedTags[0] === 'all') {
    document.querySelectorAll('.main-product__images .image-wrapper').forEach((image, i) => {
      image.classList.remove('hide');
    });

    document.querySelectorAll('.thumbnail-wrapper').forEach((image, i) => {
      image.classList.remove('hide');
    });
  } else {
    const thumbnails = [...document.querySelectorAll('.thumbnail-wrapper')];

    document.querySelectorAll('.main-product__images .image-wrapper').forEach((image, i) => {
      const imageSizeTag = image.querySelector('.image-size-tag')?.dataset.value?.split(' - ')[0]?.toLowerCase();

      if (selectedTags.includes(imageSizeTag)) {
        image.classList.remove('hide');
        thumbnails[i].classList.remove('hide');
      } else {
        image.classList.add('hide');
        thumbnails[i].classList.add('hide');
        image.parentElement.appendChild(image);
      }
    });
  }

  let imageWrappers = [...document.querySelectorAll('.main-product__images .image-wrapper:not(.hide)')];

  imageWrappers = imageWrappers.sort((a, b) => {
    return a.dataset.index - b.dataset.index;
  });

  imageWrappers.forEach((imageWrapper) => imageWrapper.classList.remove('full-width'));

  if (imageWrappers.length === 2 || imageWrappers.length === 5) {
    imageWrappers[imageWrappers.length - 1].classList.add('full-width');
  }

  imageWrappers.reverse().forEach((imageWrapper, i) => {
    imageWrapper.parentElement.prepend(imageWrapper);
  });

  document.querySelector('.main-product__images').setAttribute('data-visible-count', imageWrappers.length);
}

function registerModelSizeDropdown() {
  const imageFilterButton = document.querySelector('.image-filter__button');

  if (imageFilterButton === null) {
    return;
  }

  imageFilterButton.addEventListener('click', toggleModelSizeDropdown);

  const sizeTagNodes = [...document.querySelectorAll('.image-size-tag')];

  const sizeTags = sizeTagNodes.map((tag) => {
    return tag.dataset.value?.split(' - ')[0]?.toLowerCase();
  });

  if (sizeTags.length === 0) {
    document.querySelector('.image-filter__wrapper').classList.add('hide');
    return;
  }

  const options = [...document.querySelectorAll('.image-filter__dropdown-item:not(.all-selector)')];

  options.forEach((option) => {
    option.classList.add('hide');

    if (sizeTags.includes(option.dataset.value)) {
      option.classList.remove('hide');
    }

    option.addEventListener('click', handleModelOptionClick);
  });

  const allOption = document.querySelector('.image-filter__dropdown-item.all-selector');
  allOption.addEventListener('click', handleModelOptionClick);

  document.querySelector('.image-filter__dropdown-header__icon').addEventListener('click', closeModelSizeDropdown);
  document.querySelector('.main-product__images').addEventListener('click', closeModelSizeDropdown);
  document.querySelector('.product-details').addEventListener('click', closeModelSizeDropdown);
}

// function updateImageFilter() {
//   const imageFilterWrapper = document.querySelector('.image-filter__wrapper');

//   if (imageFilterWrapper) {
//     const top = document.querySelector('.product-details__handle').getBoundingClientRect().top - 145;
//     imageFilterWrapper.style.top = `${top}px`;
//   }

//   const imageReleaseWrapper = document.querySelector('.image-release__wrapper');

//   if (imageReleaseWrapper) {
//     const top = document.querySelector('.product-details__handle').getBoundingClientRect().top - 178;
//     imageReleaseWrapper.style.top = `${top}px`;
//   }
// }

function clickCartOnUpdate() {
  document.addEventListener('rebuy:cart.change', (event) => {
    setTimeout(() => {
      const rebuyCart = document.querySelector('.rebuy-cart');

      if (rebuyCart && rebuyCart.classList.contains('is-visible')) {
        const cartTitle = rebuyCart.querySelector('.rebuy-cart__flyout-title');

        if (cartTitle) {
          cartTitle.click();
        }
      }
    }, 1000);
  });
}

function signupForWaitlist() {
  const signupButton = document.querySelector('.product__waitlist_btn.product__waitlist_signup');
  if (!signupButton) return;

  const signupModal = document.querySelector('.product__waitlist_modal');
  const releaseName = signupButton.dataset.releaseName;
  const signupSubmit = signupModal.querySelector('.product__waitlist_modal-submit');
  const errorField = signupModal.querySelector('.error-field');
  const successField = signupModal.querySelector('.success-field');

  if (!releaseName) return;

  signupButton.addEventListener('click', () => {
    signupModal.classList.add('active');
  });

  signupSubmit.addEventListener('click', () => {
    const email = signupModal.querySelector(".product__waitlist_modal-form input[type='email']").value;
    errorField.innerHTML = '';
    successField.innerHTML = '';

    if (email == null || !email.includes('@')) {
      errorField.innerHTML = window.theme.strings.waitlist_email_error;
      return;
    }

    if (releaseName == null) {
      errorField.innerHTML = window.theme.strings.waitlist_error;
      return;
    }

    signupSubmit.classList.add('disabled');
    signupSubmit.innerHTML = window.theme.strings.waitlist_submitting;

    const productTitle = document.querySelector('.main-product__title')?.innerText?.trim();
    const productId = document.querySelector('.product__release')?.getAttribute('data-product-id');

    const subscribePayload = {
      email,
      releaseName,
      productId: productId,
      productTitle: productTitle,
    };

    fetch(`https://planetnusa-backend-323660974935.europe-west1.run.app/api/waitlist/signup`, {
      method: 'post',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(subscribePayload),
    })
      .then(() => {
        successField.innerHTML = window.theme.strings.waitlist_success;
      })
      .catch((error) => {
        console.log(error);
        errorField.innerHTML = window.theme.strings.waitlist_error;
      })
      .finally(() => {
        signupSubmit.classList.remove('disabled');
        signupSubmit.innerHTML = window.theme.strings.waitlist_submit;
      });
  });

  // Find the "release-date" element which if NOT null, get the attribute data-date, which is its a date string in UTC timezone
  const releaseDate = document.querySelector('.release-date')?.getAttribute('data-date');
  if (releaseDate) {
    // Format should be: NOV 30, 23 11:00 (MMM, dd, yy hh:mm)
    // Based on the users timezone, get the date string in their timezone
    let localReleaseDate = new Date(releaseDate).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
    // Get the AM /PM from the string
    const ampm = localReleaseDate.match(/(AM|PM)/)[0];

    // Remove AM / PM from the string
    localReleaseDate = localReleaseDate.replace(/(AM|PM)/, '');

    // Change 2023, 2024, 2025, 2027 to 23, 24, 25, 27
    localReleaseDate = localReleaseDate.replace(/(, 20)/, ', ');

    const splitDate = localReleaseDate.split(', ');
    const timeSplit = splitDate[2].split(':');

    if (timeSplit[0].length === 1) {
      timeSplit[0] = '0' + timeSplit[0];
      // Update time to be in 24 hour format
      const time = timeSplit[0];
      if (ampm == 'PM') {
        timeSplit[0] = parseInt(timeSplit[0]) + 12;
      }
    }

    if (timeSplit[1].length === 1) {
      timeSplit[1] = '0' + timeSplit[1];
    }

    splitDate[2] = timeSplit.join(':');
    localReleaseDate = splitDate.join(', ');

    // Set the release date text to the local release date
    [...document.querySelectorAll('.release-date')].forEach((date) => {
      date.innerHTML = localReleaseDate;
    });
  }
}

function signupModalClose() {
  const signupCloseButton = document.querySelector('.product__waitlist_modal .close');
  const signupOverlay = document.querySelector('.product__waitlist_modal-overlay');
  const signupModal = document.querySelector('.product__waitlist_modal');

  if (!(signupCloseButton || signupOverlay || signupModal)) return;

  signupCloseButton.addEventListener('click', () => {
    signupModal.classList.remove('active');
  });
  signupOverlay.addEventListener('click', () => {
    signupModal.classList.remove('active');
  });
}

function updateCountdown() {
  const releaseDateElements = document.querySelector('.release-date');
  if (!releaseDateElements) return; // Exit if element not found

  const productUrl = releaseDateElements.dataset.productUrl;
  const releaseDate = new Date(releaseDateElements.getAttribute('data-date')).getTime();
  const now = new Date().getTime();
  const distance = releaseDate - now;

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  const countdownTimer = document.querySelector('.countdown-timer');
  if (countdownTimer) {
    if (distance < 0) {
      if (productUrl) {
        replaceProduct(productUrl);
      } else {
        location.reload();
      }
    } else {
      countdownTimer.querySelector('.days').textContent = String(days).padStart(2, '0');
      countdownTimer.querySelector('.hours').textContent = String(hours).padStart(2, '0');
      countdownTimer.querySelector('.minutes').textContent = String(minutes).padStart(2, '0');
      countdownTimer.querySelector('.seconds').textContent = String(seconds).padStart(2, '0');
    }
  }
}

// Check if there's a countdown timer on the page
if (document.querySelector('.release-date')) {
  // Update countdown immediately
  updateCountdown();
  // Update countdown every second
  setInterval(updateCountdown, 1000);
}

// Check if there's a countdown timer on the page
if (document.querySelector('.release-date')) {
  updateCountdown();
  // Update countdown every second
  setInterval(updateCountdown, 1000);
}

function registerEvents() {
  registerColorSwatches();
  registerColorSelectorToggle();
  registerOptionSelectorOpen();
  registerImagesScroll();
  // registerNonStickyDetailsScroll();
  registerModelSizeDropdown();
  registerDesktopOptionSelectEvents();
  registerDesktopImageScrollHandler();
  registerDesktopImageThumbnails();
  updateThumbnails();
  // updateImageFilter();
  clickCartOnUpdate();
  // handleWindowResize();
  // signupModalClose();
  // signupForWaitlist();
}

registerEvents();
